import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context9, _context0; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context9 = ownKeys(Object(t), !0)).call(_context9, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context0 = ownKeys(Object(t))).call(_context0, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React from "react";
import { Typography, RaiseColors, RaiseButton, IconConstants, IconButton, Icon, CheckboxFilterGroup, ConfirmationDialog, makeStyles, AlertTypeEnum } from "componentLibrary";
import TextLink from "componentLibrary/TextLink/TextLink";
import TextField from "components/mui/Fields/Fields/TextField/TextField";
import { EnumSelectField } from "components/mui/Fields";
import { CustomFieldTypeEnum } from "utils/Enums";
import { Form, Formik } from "formik";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import CustomDropdown from "componentLibrary/CustomizeColumns/CustomDropdown";
import * as yup from "yup";
import { gql } from "@apollo/client";
import { useCreateOrganizationCustomFieldDefinitionMutation, useDeleteOrganizationCustomFieldDefinitionMutation, useEditOrganizationCustomFieldDefinitionMutation } from "raise-types";

// Custom Column Fragment
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var CustomColumnFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment CustomFieldFragment on OrganizationCustomFieldDefinitionNode {\n        id\n        name\n        fieldType\n        dropdownOptions {\n            id\n            name\n            displayOrder\n        }\n        fieldConfiguration\n        lastModifiedDate\n        createdDate\n        lastModifiedBy {\n            fullName\n        }\n        createdBy {\n            fullName\n        }\n    }\n"])));

// Export the fragment name for reuse
export var CUSTOM_FIELD_FRAGMENT_NAME = "CustomFieldFragment";
var useStyles = makeStyles(function (theme) {
  return {
    labelSpacing: {
      marginBottom: "8px"
    },
    textField: {
      height: 48,
      marginTop: 8
    },
    form: {
      border: "1px solid ".concat(RaiseColors.grayscale200),
      padding: "16px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "24px"
    },
    formWithErrors: {
      border: "1px solid ".concat(RaiseColors.destructive700)
    },
    buttonContainer: {
      display: "flex",
      gap: "8px",
      justifyContent: "flex-end"
    }
  };
});
var CreateCustomColumns = function CreateCustomColumns(_ref) {
  var _context4;
  var editingColumn = _ref.editingColumn,
    setEditingColumn = _ref.setEditingColumn,
    organizationId = _ref.organizationId,
    customColumnDefinitions = _ref.customColumnDefinitions,
    selectedColumns = _ref.selectedColumns,
    onCheckboxFilterChange = _ref.onCheckboxFilterChange,
    showAlert = _ref.showAlert,
    setSelectedColumns = _ref.setSelectedColumns,
    customColumns = _ref.customColumns,
    setCustomColumns = _ref.setCustomColumns;
  var classes = useStyles();
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    deletingColumn = _React$useState2[0],
    setDeletingColumn = _React$useState2[1];
  var _useCreateOrganizatio = useCreateOrganizationCustomFieldDefinitionMutation({
      onCompleted: function onCompleted(data) {
        var _data$createOrganizat;
        if (data !== null && data !== void 0 && (_data$createOrganizat = data.createOrganizationCustomFieldDefinition) !== null && _data$createOrganizat !== void 0 && _data$createOrganizat.errors) {
          var _data$createOrganizat2;
          showAlert({
            message: data === null || data === void 0 || (_data$createOrganizat2 = data.createOrganizationCustomFieldDefinition) === null || _data$createOrganizat2 === void 0 ? void 0 : _data$createOrganizat2.errors,
            type: AlertTypeEnum.error
          });
        } else {
          var _data$createOrganizat3;
          var newCustomField = data === null || data === void 0 || (_data$createOrganizat3 = data.createOrganizationCustomFieldDefinition) === null || _data$createOrganizat3 === void 0 ? void 0 : _data$createOrganizat3.customFieldDefinition;
          if (newCustomField !== null && newCustomField !== void 0 && newCustomField.id) {
            var _context2;
            setCustomColumns(function (prev) {
              var _context;
              return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(prev), [_objectSpread(_objectSpread({}, newCustomField), {}, {
                isChecked: true,
                isDisabled: false,
                isCustomField: true,
                label: newCustomField.name,
                isOrderable: true,
                isRemovable: true
              })]);
            });
            setSelectedColumns(_concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(selectedColumns), [{
              name: newCustomField.name,
              label: newCustomField.name,
              isCustomField: true,
              isDefault: false,
              isDisabled: false,
              isOrderable: true,
              isRemovable: true,
              id: newCustomField.id
            }]));
          }
          setEditingColumn(false);
          showAlert({
            message: "Changes saved",
            type: AlertTypeEnum.success
          });
        }
      },
      onError: function onError(error) {
        showAlert({
          message: error.message,
          type: AlertTypeEnum.error
        });
      }
    }),
    _useCreateOrganizatio2 = _slicedToArray(_useCreateOrganizatio, 1),
    createOrganizationCustomFieldDefinition = _useCreateOrganizatio2[0];
  React.useEffect(function () {
    if (customColumnDefinitions) {
      setCustomColumns(function (prev) {
        return _toConsumableArray(_mapInstanceProperty(prev).call(prev, function (column) {
          return _objectSpread(_objectSpread({
            label: column.name,
            isDisabled: false
          }, column), {}, {
            isChecked: _someInstanceProperty(selectedColumns).call(selectedColumns, function (selected) {
              return selected.id === column.id;
            }),
            isCustomField: true
          });
        }));
      });
    }
  }, [customColumnDefinitions, selectedColumns, setCustomColumns]);
  var _useDeleteOrganizatio = useDeleteOrganizationCustomFieldDefinitionMutation({
      onCompleted: function onCompleted(data) {
        var _data$deleteOrganizat;
        if (data !== null && data !== void 0 && (_data$deleteOrganizat = data.deleteOrganizationCustomFieldDefinition) !== null && _data$deleteOrganizat !== void 0 && _data$deleteOrganizat.errors) {
          var _data$deleteOrganizat2;
          showAlert({
            message: data === null || data === void 0 || (_data$deleteOrganizat2 = data.deleteOrganizationCustomFieldDefinition) === null || _data$deleteOrganizat2 === void 0 ? void 0 : _data$deleteOrganizat2.errors,
            type: AlertTypeEnum.error
          });
          setEditingColumn(false);
          setDeletingColumn(null);
        } else {
          var _data$deleteOrganizat3, _data$deleteOrganizat4, _data$deleteOrganizat5, _data$deleteOrganizat6;
          var deletedCustomFieldValuesCount = (_data$deleteOrganizat3 = data === null || data === void 0 || (_data$deleteOrganizat4 = data.deleteOrganizationCustomFieldDefinition) === null || _data$deleteOrganizat4 === void 0 ? void 0 : _data$deleteOrganizat4.deletedCustomFieldValuesCount) !== null && _data$deleteOrganizat3 !== void 0 ? _data$deleteOrganizat3 : 0;
          var dealroomsCount = (_data$deleteOrganizat5 = data === null || data === void 0 || (_data$deleteOrganizat6 = data.deleteOrganizationCustomFieldDefinition) === null || _data$deleteOrganizat6 === void 0 || (_data$deleteOrganizat6 = _data$deleteOrganizat6.organization) === null || _data$deleteOrganizat6 === void 0 || (_data$deleteOrganizat6 = _data$deleteOrganizat6.dealrooms) === null || _data$deleteOrganizat6 === void 0 ? void 0 : _data$deleteOrganizat6.count) !== null && _data$deleteOrganizat5 !== void 0 ? _data$deleteOrganizat5 : 0;
          var message = "Column removed successfully.";
          if (deletedCustomFieldValuesCount > 0 && dealroomsCount > 0) {
            var _context3;
            message += _concatInstanceProperty(_context3 = " ".concat(deletedCustomFieldValuesCount, " of ")).call(_context3, dealroomsCount, " transactions updated.");
          }
          setCustomColumns(function (prev) {
            return _filterInstanceProperty(prev).call(prev, function (column) {
              return column.id !== (deletingColumn === null || deletingColumn === void 0 ? void 0 : deletingColumn.id);
            });
          });
          setSelectedColumns(function (prev) {
            return _filterInstanceProperty(prev).call(prev, function (column) {
              return column.id !== (deletingColumn === null || deletingColumn === void 0 ? void 0 : deletingColumn.id);
            });
          });
          setEditingColumn(false);
          setDeletingColumn(null);
          showAlert({
            message: message,
            type: AlertTypeEnum.success
          });
        }
      },
      onError: function onError(error) {
        showAlert({
          message: error.message,
          type: AlertTypeEnum.error
        });
      }
    }),
    _useDeleteOrganizatio2 = _slicedToArray(_useDeleteOrganizatio, 1),
    deleteOrganizationCustomFieldDefinition = _useDeleteOrganizatio2[0];
  var _useEditOrganizationC = useEditOrganizationCustomFieldDefinitionMutation({
      onCompleted: function onCompleted(data) {
        var _data$editOrganizatio;
        if (data !== null && data !== void 0 && (_data$editOrganizatio = data.editOrganizationCustomFieldDefinition) !== null && _data$editOrganizatio !== void 0 && _data$editOrganizatio.errors) {
          var _data$editOrganizatio2;
          showAlert({
            message: data === null || data === void 0 || (_data$editOrganizatio2 = data.editOrganizationCustomFieldDefinition) === null || _data$editOrganizatio2 === void 0 ? void 0 : _data$editOrganizatio2.errors,
            type: AlertTypeEnum.error
          });
        } else {
          var _data$editOrganizatio3;
          var result = data === null || data === void 0 || (_data$editOrganizatio3 = data.editOrganizationCustomFieldDefinition) === null || _data$editOrganizatio3 === void 0 ? void 0 : _data$editOrganizatio3.customFieldDefinition;
          if (result) {
            setCustomColumns(function (prev) {
              return prev === null || prev === void 0 ? void 0 : _mapInstanceProperty(prev).call(prev, function (column) {
                return column.id === (result === null || result === void 0 ? void 0 : result.id) ? _objectSpread(_objectSpread(_objectSpread({}, column), result), {}, {
                  label: result === null || result === void 0 ? void 0 : result.name
                }) : column;
              });
            });
            setSelectedColumns(function (prev) {
              return prev === null || prev === void 0 ? void 0 : _mapInstanceProperty(prev).call(prev, function (column) {
                return column.id === (result === null || result === void 0 ? void 0 : result.id) ? _objectSpread(_objectSpread(_objectSpread({}, column), result), {}, {
                  label: result === null || result === void 0 ? void 0 : result.name
                }) : column;
              });
            });
          }
          showAlert({
            message: "Changes saved",
            type: AlertTypeEnum.success
          });
          setEditingColumn(false);
        }
      },
      onError: function onError(error) {
        showAlert({
          message: error.message,
          type: AlertTypeEnum.error
        });
      }
    }),
    _useEditOrganizationC2 = _slicedToArray(_useEditOrganizationC, 1),
    editOrganizationCustomFieldDefinition = _useEditOrganizationC2[0];
  var handleEditClick = function handleEditClick(id) {
    var returnedColumn = customColumns === null || customColumns === void 0 ? void 0 : _findInstanceProperty(customColumns).call(customColumns, function (c) {
      return c.id === id;
    });
    if (returnedColumn) {
      var _returnedColumn$dropd;
      var labelOptions = returnedColumn === null || returnedColumn === void 0 || (_returnedColumn$dropd = returnedColumn.dropdownOptions) === null || _returnedColumn$dropd === void 0 ? void 0 : _mapInstanceProperty(_returnedColumn$dropd).call(_returnedColumn$dropd, function (option) {
        return _objectSpread(_objectSpread({}, option), {}, {
          label: option === null || option === void 0 ? void 0 : option.name
        });
      });
      setEditingColumn(_objectSpread(_objectSpread({}, returnedColumn), {}, {
        dropdownOptions: labelOptions
      }));
    }
  };
  var onDelete = function onDelete(id) {
    deleteOrganizationCustomFieldDefinition({
      variables: {
        organizationId: organizationId,
        customFieldId: id
      }
    });
  };
  var emptyEditingColumn = {
    name: "",
    fieldType: "",
    value: null,
    dropdownOptions: [],
    newDropdownOption: ""
  };
  var ValidationSchema = yup.object().shape({
    name: _trimInstanceProperty(_context4 = yup.string()).call(_context4).required("Name is required").max(50, "Name must be 50 characters or less").min(1, "Name cannot be only spaces"),
    fieldType: yup.string().required("Type is required").min(1, "Type is required"),
    newDropdownOption: yup.string().when("fieldType", {
      is: "dropdown",
      then: function then(schema) {
        return _trimInstanceProperty(schema).call(schema).max(100, "New dropdown option must be 100 characters or less").test("dropdown-options-required", "At least one option is required", function () {
          var dropdownOptions = this.parent.dropdownOptions;
          return dropdownOptions && dropdownOptions.length >= 1;
        });
      },
      otherwise: function otherwise(schema) {
        return schema.optional();
      }
    })
  });
  var hasFormErrors = function hasFormErrors(errors) {
    var _context5, _context6;
    var hasDropdownErrors = errors.dropdownOptions && _someInstanceProperty(_context5 = _Object$values(errors.dropdownOptions)).call(_context5, function (error) {
      return typeof error === "string" && error.length > 0;
    });
    var hasOtherErrors = _someInstanceProperty(_context6 = _Object$keys(errors)).call(_context6, function (key) {
      return key !== "dropdownOptions" && errors[key];
    });
    return hasDropdownErrors || hasOtherErrors;
  };
  return /*#__PURE__*/_jsx("div", {
    children: editingColumn !== false ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Formik, {
        enableReinitialize: true,
        validationSchema: ValidationSchema,
        initialValues: editingColumn ? editingColumn : emptyEditingColumn,
        onSubmit: function onSubmit(values) {
          if (!(values !== null && values !== void 0 && values.id)) {
            var _values$dropdownOptio;
            createOrganizationCustomFieldDefinition({
              variables: {
                organizationId: organizationId,
                customFieldInput: {
                  name: values === null || values === void 0 ? void 0 : values.name,
                  fieldType: values === null || values === void 0 ? void 0 : values.fieldType,
                  dropdownOptions: values === null || values === void 0 || (_values$dropdownOptio = values.dropdownOptions) === null || _values$dropdownOptio === void 0 ? void 0 : _mapInstanceProperty(_values$dropdownOptio).call(_values$dropdownOptio, function (option, index) {
                    return {
                      name: option.name,
                      displayOrder: index + 1
                    };
                  })
                }
              }
            });
          } else {
            var _values$dropdownOptio2;
            editOrganizationCustomFieldDefinition({
              variables: {
                organizationId: organizationId,
                customFieldId: values === null || values === void 0 ? void 0 : values.id,
                customFieldInput: {
                  name: values === null || values === void 0 ? void 0 : values.name,
                  dropdownOptions: values === null || values === void 0 || (_values$dropdownOptio2 = values.dropdownOptions) === null || _values$dropdownOptio2 === void 0 ? void 0 : _mapInstanceProperty(_values$dropdownOptio2).call(_values$dropdownOptio2, function (option, index) {
                    return {
                      id: option.id,
                      name: option.name,
                      displayOrder: index + 1
                    };
                  })
                }
              }
            });
          }
        },
        validateOnChange: false,
        validateOnBlur: false,
        children: function children(formikUtils) {
          var _context7;
          var values = _valuesInstanceProperty(formikUtils),
            handleChange = formikUtils.handleChange,
            submitForm = formikUtils.submitForm,
            setFieldValue = formikUtils.setFieldValue,
            setValues = formikUtils.setValues,
            errors = formikUtils.errors,
            setErrors = formikUtils.setErrors;
          var isNew = !(values !== null && values !== void 0 && values.id);
          var handleDragableChange = function handleDragableChange(event) {
            var value = event.target.value;
            setFieldValue("dropdownOptions", value);
          };
          return /*#__PURE__*/_jsxs(Form, {
            className: _concatInstanceProperty(_context7 = "".concat(classes.form, " ")).call(_context7, hasFormErrors(errors) ? classes.formWithErrors : ""),
            children: [/*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                className: classes.labelSpacing,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph_small",
                  weight: "medium",
                  children: "Name*"
                })
              }), /*#__PURE__*/_jsx(MuiFormikField, {
                Component: TextField,
                defaultValue: values === null || values === void 0 ? void 0 : values.name,
                name: "name",
                placeholder: "Enter name",
                fullWidth: true,
                onChange: handleChange,
                editMode: true,
                size: "small"
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("div", {
                className: classes.labelSpacing,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph_small",
                  weight: "medium",
                  children: "Type*"
                })
              }), /*#__PURE__*/_jsx(MuiFormikField, {
                Component: EnumSelectField,
                name: "fieldType",
                fullWidth: true,
                enumObject: CustomFieldTypeEnum,
                value: values.fieldType,
                onChange: handleChange,
                displayEmpty: true,
                disabled: !isNew,
                renderValue: function renderValue(value) {
                  var _Object$values$find, _context8;
                  if (!value) {
                    return /*#__PURE__*/_jsx(Typography, {
                      color: RaiseColors.grayscale900,
                      variant: "paragraph_small",
                      children: "Select type"
                    });
                  }
                  var selectedValue = (_Object$values$find = _findInstanceProperty(_context8 = _Object$values(_valuesInstanceProperty(CustomFieldTypeEnum))).call(_context8, function (option) {
                    return option.value === value;
                  })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.label;
                  return /*#__PURE__*/_jsx(Typography, {
                    variant: "paragraph_small",
                    children: selectedValue
                  });
                }
              })]
            }), values.fieldType === CustomFieldTypeEnum.DROPDOWN.value && /*#__PURE__*/_jsx(CustomDropdown, {
              values: values,
              setValues: setValues,
              handleChange: handleChange,
              handleDragableChange: handleDragableChange,
              labelSpacing: classes.labelSpacing,
              errors: errors,
              setErrors: setErrors
            }), /*#__PURE__*/_jsxs("div", {
              className: classes.buttonContainer,
              children: [/*#__PURE__*/_jsx(RaiseButton, {
                variant: "text",
                size: "medium",
                onClick: function onClick() {
                  return setEditingColumn(false);
                },
                children: "Cancel"
              }), /*#__PURE__*/_jsx(RaiseButton, {
                variant: "primary",
                size: "medium",
                onClick: function onClick() {
                  submitForm();
                },
                children: isNew ? "Create" : "Save"
              })]
            })]
          });
        }
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(CheckboxFilterGroup, {
          filterName: "checkGroup",
          checkboxGroupElements: customColumns,
          onChange: onCheckboxFilterChange,
          actionButtons: [function (element) {
            return /*#__PURE__*/_jsx(IconButton, {
              variant: "animatedIconSmall",
              size: "small",
              onClick: function onClick() {
                return handleEditClick(element.id);
              },
              children: /*#__PURE__*/_jsx(Icon, {
                color: RaiseColors.midnightPurple,
                fontSize: 16,
                className: IconConstants.PENCIL
              })
            }, "edit-".concat(element.id));
          }, function (element) {
            return /*#__PURE__*/_jsx(IconButton, {
              variant: "animatedIconSmall",
              size: "small",
              onClick: function onClick() {
                return setDeletingColumn(element);
              },
              children: /*#__PURE__*/_jsx(Icon, {
                color: RaiseColors.midnightPurple,
                fontSize: 16,
                className: IconConstants.TRASH
              })
            }, "delete-".concat(element.id));
          }]
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          marginTop: "16px"
        },
        children: /*#__PURE__*/_jsx(TextLink, {
          onClick: function onClick() {
            return setEditingColumn(emptyEditingColumn);
          },
          children: "+ Add Column"
        })
      }), !!deletingColumn ? /*#__PURE__*/_jsx(ConfirmationDialog, {
        title: "Delete Column",
        bodyMessage: "You are about to delete the '".concat(deletingColumn === null || deletingColumn === void 0 ? void 0 : deletingColumn.label, "' column. This action will permanently remove all data in this column and cannot be undone."),
        open: !!deletingColumn,
        onClose: function onClose() {
          return setDeletingColumn(null);
        },
        onCancel: function onCancel() {
          return setDeletingColumn(null);
        },
        onConfirm: function onConfirm() {
          return onDelete(deletingColumn === null || deletingColumn === void 0 ? void 0 : deletingColumn.id);
        },
        disableCloseOnBackdropClick: true
      }) : null]
    })
  });
};
export default CreateCustomColumns;
gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    mutation CreateOrganizationCustomFieldDefinition(\n        $organizationId: UUID!\n        $customFieldInput: CustomFieldDefinitionInput!\n    ) {\n        createOrganizationCustomFieldDefinition(\n            organizationId: $organizationId\n            customFieldInput: $customFieldInput\n        ) {\n            errors\n            customFieldDefinition {\n                ...CustomFieldFragment\n            }\n        }\n    }\n    ", "\n"])), CustomColumnFragment);
gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    mutation DeleteOrganizationCustomFieldDefinition(\n        $organizationId: UUID!\n        $customFieldId: UUID!\n    ) {\n        deleteOrganizationCustomFieldDefinition(\n            organizationId: $organizationId\n            customFieldId: $customFieldId\n        ) {\n            errors\n            deletedCustomFieldValuesCount\n            organization {\n                id\n                dealrooms {\n                    count\n                }\n\n                customFieldDefinitions {\n                    id\n                    ...CustomFieldFragment\n                }\n            }\n        }\n    }\n    ", "\n"])), CustomColumnFragment);
gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    mutation EditOrganizationCustomFieldDefinition(\n        $organizationId: UUID!\n        $customFieldId: UUID!\n        $customFieldInput: EditCustomFieldDefinitionInput!\n    ) {\n        editOrganizationCustomFieldDefinition(\n            organizationId: $organizationId\n            customFieldId: $customFieldId\n            customFieldInput: $customFieldInput\n        ) {\n            errors\n            customFieldDefinition {\n                ...CustomFieldFragment\n            }\n        }\n    }\n    ", "\n"])), CustomColumnFragment);